import { render, staticRenderFns } from "./birthdayRight.vue?vue&type=template&id=07e8f377&scoped=true&"
import script from "./birthdayRight.vue?vue&type=script&lang=js&"
export * from "./birthdayRight.vue?vue&type=script&lang=js&"
import style0 from "./birthdayRight.vue?vue&type=style&index=0&id=07e8f377&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e8f377",
  null
  
)

export default component.exports